<template>
    <div class="mobile">
        <img class="bg"
             src="https://res.ldmnq.com/ldq_website/img/mobile/mobile-bg.png"
             alt="">
        <head-nav ref="nav"></head-nav>
        <div @touchstart='touchStart'
             @touchend='touchEnd'
             :class="['view-area','scroll-' + idx]">
            <div class="mobile-content">
                <div class="mobile-content-title">
                    24小时托管神器
                </div>
                <div class="mobile-content-title-bold">
                    您的另一台手机
                </div>
                <div class="mobile-content-p">
                    永不掉线、永不关机、永不发烫、无需充电
                </div>
                <img class="mobile-content-img"
                     src="https://res.ldmnq.com/ldq_website/img/mobile/one.png"
                     alt="">
            </div>
            <div class="mobile-content">
                <div class="mobile-content-title">
                    云端多开
                </div>
                <div class="mobile-content-title-bold">
                    游戏活力全开
                </div>
                <div class="mobile-content-p">
                    一台手机变多台，手机同屏预览更便捷
                </div>
                <img class="mobile-content-img"
                     src="https://res.ldmnq.com/ldq_website/img/mobile/two.png"
                     alt="">
            </div>
            <div class="mobile-content">
                <div class="mobile-content-title">
                    营销必备
                </div>
                <div class="mobile-content-title-bold">
                    赚钱的好帮手
                </div>
                <div class="mobile-content-p">
                    一键批量搞定，云端数据更安全
                </div>
                <img class="mobile-content-img"
                     src="https://res.ldmnq.com/ldq_website/img/mobile/thr.png"
                     alt="">
            </div>
            <div class="mobile-content">
                <div class="mobile-content-title-bold margin-top">
                    新手使用教程
                </div>
                <img class="mobile-content-img"
                     src="https://res.ldmnq.com/ldq_website/img/mobile/for.png"
                     alt="">
            </div>
        </div>
        <div class="mobile-btn"
             id="mobile-download"
             @click="download">
            <img src="https://res.ldmnq.com/ldq_website/img/android-icon.png"
                 alt="">
            Android下载
        </div>
        <img v-if="idx !== 3"
             @click="changeIdx"
             src="https://res.ldmnq.com/ldq_website/img/mobile/scroll.png"
             alt=""
             class="scroll-down">
        <div v-if="idx === 3"
             class="stealth-div"
             @click="gotoWatch"></div>
    </div>
</template>

<script>
import HeadNav from './components/head-nav'
export default {
    components: {
        HeadNav
    },
    data() {
        return {
            idx: 0,
            startX: 0, //开始触摸的位置
            endX: 0, //结束触摸的位置
            disX: 0 //移动距离
        }
    },
    methods: {
        changeIdx() {
            this.idx = this.idx + 1
        },
        touchStart(ev) {
            ev = ev || event;
            // ev.preventDefault() 阻止默认事件
            ev.preventDefault()
            if (ev.touches.length == 1) {
                this.$refs.nav.show = false
                this.startX = ev.touches[0].clientY
            }
        },
        touchEnd(ev) {
            ev = ev || event;
            ev.preventDefault()
            if (ev.changedTouches.length == 1) {
                this.endX = ev.changedTouches[0].clientY
                this.disX = this.endX - this.startX
            }
        },
        gotoWatch() {
            window.location.href = 'https://res.ldmnq.com/gw/ldy/yunphone/video.mp4'
        },
        download() {
            _hmt.push(['_trackEvent', '移动端下载', 'mobile-download'])
            let downloadUrl = 'https://ldq.ldmnq.com/download'
            let url = location.href
            if(url.indexOf('ldyun1') > -1){
                downloadUrl = 'https://res.ldmnq.com/ldy/2009/YunPhone-toutiao1-2.4.0.apk'
            }
            else if(url.indexOf('ldyun2') > -1){
                downloadUrl = 'https://res.ldmnq.com/ldy/2009/YunPhone-toutiao2-2.4.0.apk '
            }
            else if(url.indexOf('ldyun3') > -1){
                downloadUrl = 'https://res.ldmnq.com/ldy/2009/YunPhone-toutiao3-2.4.0.apk'
            }
            else if(url.indexOf('ldyun4') > -1){
                downloadUrl = 'https://res.ldmnq.com/ldy/2009/YunPhone-luodiye-2.4.0.apk'
            }
            else if(url.indexOf('360ldy') > -1){
                downloadUrl = 'https://res.ldmnq.com/ldy/2101/YunPhone-SEM-3.0.5.apk'
            }
            else if(url.indexOf('360') > -1){
                downloadUrl = 'https://res.ldmnq.com/ldy/2102/YunPhone-360-3.0.8.apk'
            }
            else if(url.indexOf('bd') > -1){
                downloadUrl = 'https://res.ldmnq.com/ldy/2102/YunPhone-bd-3.0.8.apk'
            }
            else if(url.indexOf('sougou') > -1){
                downloadUrl = 'https://res.ldmnq.com/ldy/2102/YunPhone-sougou-3.0.8.apk'
            }
            window.location.href = downloadUrl
        }
    },
    watch: {
        disX(val) {
            if(Math.abs(val) < 10){
                return
            }
            if (val > 0) {
                if(this.idx === 0){
                    return
                }
                this.idx = this.idx - 1
            }
            else {
                if(this.idx === 3){
                    return
                }
                this.idx = this.idx + 1
            }
        }
    }
}
</script>

<style lang='scss' scoped>
.mobile {
    height: 100vh;
    overflow: hidden;
}
.bg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    object-fit: cover;
    z-index: -1;
}
.view-area {
    transition: 0.5s all;
}
.scroll-0 {
    transform: translate3d(0, 0, 0);
}
.scroll-1 {
    transform: translate3d(0, -100vh, 0);
}
.scroll-2 {
    transform: translate3d(0, -200vh, 0);
}
.scroll-3 {
    transform: translate3d(0, -300vh, 0);
}
.mobile-content {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    // justify-content: space-between;
    color: #f4c51f;
    // padding: 0 0 25vh 0;
    .mobile-content-title {
        margin: 238px 0 20px;
        font-weight: bold;
        font-size: 80px;
        text-align: center;
    }
    .mobile-content-title-bold {
        font-weight: bold;
        font-size: 130px;
        text-align: center;
    }
    .mobile-content-p {
        margin: 40px 0 102px;
        font-weight: 300;
        font-size: 44px;
        color: #fff;
    }
    .mobile-content-img {
        width: 960px;
        height: 750px;
    }
    .margin-top {
        margin-top: 400px;
    }
}
.mobile-btn {
    position: fixed;
    bottom: 180px;
    left: 50%;
    transform: translate3d(-50%, 0, 0);
    width: 900px;
    height: 150px;
    background: #f4c51f;
    border-radius: 90px;
    display: flex;
    align-items: center;
    padding-left: 228px;
    font-size: 48px;
    color: #000;
    img {
        width: 108px;
        height: 108px;
        margin-right: 48px;
    }
}
.scroll-down {
    position: fixed;
    bottom: 60px;
    left: 50%;
    transform: translate3d(-50%, 0, 0);
    width: 72px;
    height: 72px;
    animation: scroll 2s linear infinite;
    opacity: 1;
}
.stealth-div {
    position: fixed;
    top: 672px;
    left: 116px;
    width: 850px;
    height: 502px;
    opacity: 0;
}
@keyframes scroll {
    0% {
    }
    50% {
        transform: translate3d(-50%, 5px, 0);
        opacity: 0.5;
    }
    100% {
        transform: translate3d(-50%, 0, 0);
        opacity: 1;
    }
}
</style>
